<a class="new-cars-model-card__link" [routerLink]="data.url">
    <div class="new-cars-model-card__image-wrapper">
        <img
            class="new-cars-model-card__image swiper-lazy"
            [alt]="data.modelName"
            [attr.data-src]="imageSrc"
            [attr.src]="isInSlider ? undefined : imageSrc"
            width="400"
            height="332"
        />

        <div
            class="campaign-tag"
            *ngIf="data?.activeCampaign"
            [innerText]="'car_data.campaign_label_text' | translate"
        ></div>
    </div>

    <div class="new-cars-model-card__content">
        <h2 class="new-cars-model-card__header" [innerText]="data.modelName"></h2>

        <div
            class="new-cars-model-card__description"
            *ngIf="data?.shortDescription"
            [innerText]="data.shortDescription"
        ></div>
    </div>
</a>

<div class="new-cars-model-card__prices" *ngIf="!isLeasingSite && data?.startPrice">
    <div class="new-cars-model-card__price">
        <div
            class="new-cars-model-card__price-label"
            [innerText]="'car_data.starting_price_from' | translate"
        ></div>

        <div
            class="new-cars-model-card__price-value"
            [innerText]="data.startPrice | defaultcurrency"
        ></div>
    </div>
    <div class="new-cars-model-card__price">
        <div class="new-cars-model-card__price-label">
            <span [innerText]="'car_data.starting_loan_from' | translate"></span>

            <button
                class="button--mini"
                type="button"
                [innerText]="'car_data.calculate_loan_button_text' | translate"
                (click)="showLoanSimulator(data.startPrice)"
            ></button>
        </div>

        <div class="new-cars-model-card__price-value">
            <app-vehicle-loan-calculation
                [objectPrice]="data.startPrice"
            ></app-vehicle-loan-calculation>
        </div>
    </div>
</div>
